import {getRequest} from "../api";
import {mapReqOptions} from "../utils";

export const getSnapshotsList = (query, options) => {
  const reqData = {
    query,
    ...mapReqOptions(options)
  };

  return getRequest("/investigation/search", reqData, {
    serverOptions: {privateURL: true}
  });
};
